module.exports = __webpack_public_path__ + "img/logo1 (16).8af4cbfd.jpg";